import React from "react";
import { historicalDownloadHandler } from "../common/UppHelper";

const HistoricalDownloadMenu = ({
  reportName,
  selectedFundOption,
  startDate,
  endDate,
  show = true,
}) => {
  if (!show) {
    return null;
  }

  const dropdownId = `historicalDownloadMenu-${reportName}`;

  const handleDownload = (fileType) => {
    historicalDownloadHandler(
      fileType,
      reportName,
      selectedFundOption,
      startDate,
      endDate
    );
  };

  return (
    <div className="dropdown downloadIcon historical-button-download">
      <button
        className="download-button dropdown-toggle"
        type="button"
        id={dropdownId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ width: "135px" }}
      >
        Download
      </button>

      <ul
        className="dropdown-menu dropdown-menu-end"
        aria-labelledby={dropdownId}
      >
        <li>
          <button
            type="button"
            onClick={() => handleDownload("pdf")}
            className="dropdown-item"
          >
            Acrobat (PDF) file
          </button>
        </li>

        <li>
          <button
            type="button"
            onClick={() => handleDownload("csv")}
            className="dropdown-item"
          >
            CSV (comma delimited)
          </button>
        </li>

        <li>
          <button
            type="button"
            onClick={() => handleDownload("xlsx")}
            className="dropdown-item"
          >
            Excel
          </button>
        </li>

        <li>
          <button
            type="button"
            onClick={() => handleDownload("xml")}
            className="dropdown-item"
          >
            XML file with report data
          </button>
        </li>
      </ul>
    </div>
  );
};

export default HistoricalDownloadMenu;